export default import.meta.ROLLDOWN_FILE_URL__lqz23URe_hs5RkTvgMAIQ